export default __webpack_public_path__ + "static/rollingpin-e64707147132bb71560c44826fbc5f12.png";